import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { SidenavHeaderModule } from 'src/app/components/sidenav-header/sidenav-header.module';
import { DeployInstanceFormModule } from 'src/app/main/service/deploy-instance-form/deploy-instance-form.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { DeployInstanceComponent } from './deploy-instance.component';
import { ErrorDialogModule } from 'src/app/components/error-dialog/error-dialog.module';


@NgModule({
  declarations: [
    DeployInstanceComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    MatDividerModule,
    DeployInstanceFormModule,
    SidenavHeaderModule,
    ErrorDialogModule
  ],
  exports: [
    DeployInstanceComponent
  ]
})
export class DeployInstanceModule { }
